/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'

import { Icon, InfoFilled, Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

const PROMPT_ID = 'scene-technical-prompt'

function Scene({ isScene, isSceneConfirmed, onSceneAnswer }) {
  const isAwaitingReview = isScene && !isSceneConfirmed
  const prompt = i18n.t('rails:publisher.scene.detected_prompt')

  function handleChange(event) {
    onSceneAnswer(event.target.checked)
  }

  return (
    <div className="technical-details__scene-check">
      <input
        type="checkbox"
        id="scene-technical"
        className="checkbox"
        checked={isScene}
        onChange={handleChange}
        aria-describedby={isAwaitingReview ? PROMPT_ID : undefined}
      />
      <label htmlFor="scene-technical">{i18n.t('rails:publisher.scene.label')}</label>
      {isAwaitingReview && (
        <>
          <span id={PROMPT_ID} className="sr-only">{prompt}</span>
          <Tooltip id="scene-technical-tooltip" content={prompt} tooltipClassName="tooltip--normal-weight">
            <Icon
              svgComponent={InfoFilled}
              color="primary"
              size="small"
              className="technical-details__scene-hint"
            />
          </Tooltip>
        </>
      )}
    </div>
  )
}

Scene.propTypes = {
  isScene: bool.isRequired,
  isSceneConfirmed: bool.isRequired,
  onSceneAnswer: func.isRequired,
}

export default Scene
